module.exports = __webpack_public_path__ + "img/litcom.f0e19c27.jpg";